if (!customElements.get('amped-home-banners')) {
  customElements.define('amped-home-banners', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('.ag-banner__slide')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.updateToggle();
      this.schedule();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.schedule();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && !this.focused && !document.hidden && this.slides.length > 1) {
        this.timer = setTimeout(() => this.show(this.index + 1), 5000);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}
